module.exports = __webpack_public_path__ + "static/media/outlook-icon.0865d8bd.svg";